import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useEffect, useRef, useState } from 'react';
import BankForm, { BankFormRef, BankValues } from './BankForm';

type EditBankModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (params: BankValues) => Promise<void>;
  data: IBank;
};

const EditBankModal: React.FC<EditBankModalProps> = ({
  isOpen,
  toggle,
  data,
  onSubmit,
}: EditBankModalProps) => {
  const { messages } = useTypedIntl();
  const formRef = useRef<BankFormRef>(null);

  useEffect(() => {
    if (isOpen && data) {
      formRef.current?.setFieldsValue({
        bankName: data?.bankName
          ? { label: data.bankName, value: data.bankName }
          : null,
        accountName: data?.accountName || '',
        accountNumber: data?.accountNumber || '',
        sortCode: data?.sortCode || '',
        isPrimary: data?.isPrimary || false,
        IBANReference: data?.IBANReference || '',
        bankReference: data?.bankReference || '',
        BIC: data?.BIC || '',
        orgId: data?.orgId || '',
      });
    }
  }, [isOpen, data]);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: BankValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.editBank']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <BankForm
        formRef={formRef}
        onSubmit={handleSubmit}
        defaultValues={{
          bankName: data?.bankName
            ? { label: data.bankName, value: data.bankName }
            : null,
          accountName: data?.accountName || '',
          accountNumber: data?.accountNumber || '',
          sortCode: data?.sortCode || '',
          isPrimary: data?.isPrimary || false,
          IBANReference: data?.IBANReference || '',
          bankReference: data?.bankReference || '',
          BIC: data?.BIC || '',
          orgId: data?.orgId || '',
        }}
      />
    </AppModalContainer>
  );
};

export default EditBankModal;
